import React from 'react';

/** Neutral "nothing here" panel, used wherever a list legitimately has no rows. */
const EmptyState = ({ title, body, action = null, tone = 'default' }) => (
  <div className={`td-empty td-empty--${tone}`}>
    <p className="td-empty__title">{title}</p>
    {body ? <p className="td-empty__body">{body}</p> : null}
    {action}
  </div>
);

export default EmptyState;
